<template>
    <div class="sl-wrap">
        <div class="sl-card">
            <!-- Logo établissement / produit -->
            <img src="/assets/logopaie.png" alt="HSIGCOM" class="sl-logo" />

            <!-- État CHARGEMENT : on résout le code -->
            <template v-if="etat === 'chargement'">
                <div class="sl-spinner" aria-hidden="true"></div>
                <p class="sl-titre">Authentification…</p>
                <p class="sl-sous">Vérification de votre accès, un instant.</p>
            </template>

            <!-- État ERREUR : code invalide ou expiré -->
            <template v-else-if="etat === 'refus'">
                <div class="sl-icone sl-ko" aria-hidden="true">
                    <i class="ri-close-line"></i>
                </div>
                <p class="sl-titre">Authentification non correcte</p>
                <p class="sl-sous">{{ messageRefus }}</p>
            </template>

            <!-- État RÉSEAU : panne temporaire, on propose de réessayer -->
            <template v-else>
                <div class="sl-icone sl-warn" aria-hidden="true">
                    <i class="ri-wifi-off-line"></i>
                </div>
                <p class="sl-titre">Connexion indisponible</p>
                <p class="sl-sous">Vérifiez votre connexion, puis réessayez.</p>
                <button class="sl-btn" @click="resoudre">Réessayer</button>
            </template>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
/**
 * Page interstitielle du raccourcisseur de QR (route publique /s/:code).
 *
 * Le QR ne contient qu'un code court. Cette page l'ouvre dans un navigateur,
 * demande au backend la cible réelle (route publique resolve), puis redirige :
 *  - succès  → window.location.replace(cible) (chemin interne : /panier, /menu, /serveur) ;
 *  - refus   → « Authentification non correcte » (code inconnu ou expiré) ;
 *  - réseau  → écran « Connexion indisponible » avec bouton Réessayer.
 *
 * Volontairement minimale (aucun bootstrap Scan & Go, aucune IndexedDB) : elle
 * doit s'afficher instantanément, c'est tout l'intérêt du QR raccourci.
 */
import { resoudreShortlink } from "@/service/hsigscangoIndexdb";

export default {
    name: "shortlinkapp",
    data: () => ({
        etat: "chargement",           // 'chargement' | 'refus' | 'reseau'
        messageRefus: "Ce code n'est plus valide ou a expiré.",
    }),
    methods: {
        async resoudre() {
            this.etat = "chargement";
            const code = String(this.$route.params.code || "").trim();
            if (!code) {
                this.etat = "refus";
                this.messageRefus = "Aucun code fourni.";
                return;
            }

            const r = await resoudreShortlink({ code });

            if (r.status === "ok" && r.cible) {
                // Cible = chemin interne relatif → résolu contre l'origine courante.
                window.location.replace(r.cible);
                return;
            }
            if (r.status === "denied") {
                this.etat = "refus";
                this.messageRefus = r.code === "EXPIRED"
                    ? "Ce code a expiré. Demandez-en un nouveau."
                    : "Ce code est invalide.";
                return;
            }
            // Panne réseau : on garde l'espoir, l'utilisateur peut réessayer.
            this.etat = "reseau";
        },
    },
    mounted() {
        this.resoudre();
    },
};
</script>

<style scoped>
.sl-wrap {
    position: fixed;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: #f4f7f6;
}
.sl-card {
    width: 100%;
    max-width: 340px;
    background: #ffffff;
    border-radius: 18px;
    box-shadow: 0 10px 40px rgba(15, 110, 86, 0.12);
    padding: 32px 24px;
    text-align: center;
}
.sl-logo {
    height: 34px;
    width: auto;
    object-fit: contain;
    margin-bottom: 22px;
    opacity: 0.9;
}
.sl-titre {
    font-family: Arial, sans-serif;
    font-size: 18px;
    font-weight: 700;
    color: #0f2f28;
    margin: 14px 0 6px;
}
.sl-sous {
    font-family: Arial, sans-serif;
    font-size: 14px;
    color: #5c6b67;
    margin: 0;
    line-height: 1.4;
}
.sl-spinner {
    width: 46px;
    height: 46px;
    margin: 4px auto 4px;
    border: 4px solid #dbe7e3;
    border-top-color: #0f6e56;
    border-radius: 50%;
    animation: sl-spin 0.9s linear infinite;
}
@keyframes sl-spin {
    to { transform: rotate(360deg); }
}
.sl-icone {
    width: 56px;
    height: 56px;
    margin: 0 auto 4px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    color: #ffffff;
}
.sl-ko { background: #d64545; }
.sl-warn { background: #e0a92e; }
.sl-btn {
    margin-top: 18px;
    border: none;
    background: #0f6e56;
    color: #ffffff;
    font-family: Arial, sans-serif;
    font-size: 15px;
    font-weight: 600;
    padding: 11px 22px;
    border-radius: 10px;
    cursor: pointer;
}
.sl-btn:active { transform: translateY(1px); }
</style>
